<template>
  <div class="container">
    <div class="info">
      <h1>Central de Privacidade</h1>
      <h2>CREDITALL GESTAO E GARANTIA DE CREDITO</h2>
      <p>
        A proteção de dados pessoais é um elemento crucial no desenvolvimento de todos os nossos produtos e serviços.
        <br /><br />
        Como relacionamentos bem-sucedidos exigem confiança mútua e entendimento compartilhado, buscamos <b>total transparência</b> na maneira como lidamos com os seus dados pessoais.
        <br />
        O respeito pela sua privacidade orienta a forma como escolhemos nossos parceiros de negócios, projetamos nossos produtos e serviços e lidamos com seus dados pessoais.
        <br />
        Seja você um consumidor, cliente ou parceiro de negócios, <b>garantimos</b> que você mantenha o controle sobre como seus dados são gerenciados, processados e armazenados.
        <br /><br />
        Para qualquer questionamento, sinta-se à vontade para entrar em contato conosco pelo formulário:
      </p>
    </div>
    <form class="formulario" @submit.prevent="enviarFormulario">
      <h2>Formulário de Privacidade</h2>
      <label>Nome Completo</label>
      <input v-model="form.nome" required />

      <label>CPF ou CNPJ</label>
      <input v-model="form.cpf" required placeholder="CPF ou CNPJ" @input="form.cpf = maskCpfCnpj(form.cpf)" maxlength="18" />

      <label>Email</label>
      <input v-model="form.email" type="email" required />

      <label>Telefone</label>
      <input v-model="form.telefone" required placeholder="(11)98765-4321" @input="form.telefone = maskTelefone(form.telefone)" maxlength="15" />

      <label>Motivo do Contato</label>
      <select v-model="form.motivo" required>
        <option disabled value="">Clique para selecionar</option>
        <option>Solicitação de acesso</option>
        <option>Exclusão de dados</option>
        <option>Atualização de dados</option>
        <option>Outro</option>
      </select>

      <label>Descrição</label>
      <textarea v-model="form.descricao" required></textarea>

      <button type="submit">Enviar Pedido de Privacidade</button>
      <p v-if="mensagem" :class="{'sucesso': sucesso, 'erro': !sucesso}">{{ mensagem }}</p>
    </form>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import axios from 'axios'

const form = ref({
  nome: '',
  cpf: '',
  email: '',
  telefone: '',
  motivo: '',
  descricao: ''
})

const mensagem = ref('')
const sucesso = ref(false)

function maskCpfCnpj(value) {
  value = value.replace(/\D/g, '')
  if (value.length <= 11) {
    // CPF: 000.000.000-00
    value = value
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})$/, '$1-$2')
      .replace(/(-\d{2})\d+?$/, '$1')
  } else {
    // CNPJ: 00.000.000/0000-00
    value = value
      .replace(/^(\d{2})(\d)/, '$1.$2')
      .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/\.(\d{3})(\d)/, '.$1/$2')
      .replace(/(\d{4})(\d)/, '$1-$2')
      .replace(/(-\d{2})\d+?$/, '$1')
  }
  return value
}

function maskTelefone(value) {
  return value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{5})(\d)/, '$1-$2')
    .replace(/(-\d{4})\d+?$/, '$1')
}

async function enviarFormulario() {
    //Validação 
  for (const campo in form.value) {
    if (!form.value[campo]) {
      mensagem.value = 'Por favor, preencha todos os campos antes de enviar.'
      sucesso.value = false
      return
    }
  }

  try {
    const params = new URLSearchParams({
      email_lgpd: 'true',
      nome: form.value.nome,
      cpf: form.value.cpf,
      email: form.value.email,
      telefone: form.value.telefone,
      motivo: form.value.motivo,
      descricao: form.value.descricao
    }).toString()

    await axios.post(`http://localhost:8081/siscred/web_rest.php?${params}`)
    mensagem.value = 'Pedido enviado com sucesso!'
    sucesso.value = true
    Object.keys(form.value).forEach(k => form.value[k] = '')
  } catch (e) {
    mensagem.value = 'Erro ao enviar. Tente novamente.'
    sucesso.value = false
  }
}
</script>

<style scoped>
.container {
  display: flex;
  justify-content: space-between;
  padding: 40px;
  background: #f7f7fa;
  min-height: 100vh;
}
.info {
  width: 50%;
  padding-right: 40px;
}
.formulario {
  width: 45%;
  background: #fff;
  padding: 32px;
  border-radius: 8px;
  box-shadow: 0 2px 8px #0001;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.formulario h2 {
  color: #bf1b39;
  margin-bottom: 16px;
}
.formulario label {
  font-weight: bold;
  margin-top: 8px;
}
.formulario input,
.formulario select,
.formulario textarea {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.formulario button {
  background: #bf1b39;
  color: #fff;
  border: none;
  padding: 14px;
  border-radius: 6px;
  font-weight: bold;
  cursor: pointer;
  margin-top: 16px;
}
.sucesso { color: green; }
.erro { color: red; }
</style>